export const FIELDS = {
  ID: 'id',
  REJECT_DATE: 'rejectDate',
  STATUS_ID: 'statusId',
  STATUS_NAME: 'statusName',
  CUSTOMER_ID: 'customerId',
  CUSTOMER_NAME: 'customerName',
  CUSTOMER_PO: 'customerPo',
  VENDOR_ID: 'vendorId',
  VENDOR_NAME: 'vendorName',
  INVOICE_ID: 'invoiceId',
  INVOICE_LINE_ID: 'invoiceLineId',
  PURCHASE_ORDER_ID: 'purchaseOrderId',
  PURCHASE_ORDER_LINE_ID: 'purchaseOrderLineId',
  PART_ID: 'partId',
  PART_NUMBER: 'partNumber',
  QUANTITY: 'quantity',
  SECTION1: 'section1',
  SECTION2: 'section2',
  SECTION3: 'section3',
  SECTION4: 'section4',
  SECTION5: 'section5',
  PRODUCT_ENGINEER_NAME: 'productEngineerName',
  PRODUCT_ENGINEER_SIGNATURE_BASE64_DATA_TYPE: 'productEngineerSignatureBase64DataType',
  PRODUCT_ENGINEER_SIGNATURE: 'productEngineerSignature',
  PRODUCT_ENGINEER_APPROVED: 'productEngineerApproved',
  PRODUCT_ENGINEER_DATE: 'productEngineerDate',
  SUPPLIER_QANAME: 'supplierQaName',
  SUPPLIER_QASIGNATURE_BASE64_DATA_TYPE: 'supplierQaSignatureBase64DataType',
  SUPPLIER_QASIGNATURE: 'supplierQaSignature',
  SUPPLIER_QAAPPROVED: 'supplierQaApproved',
  SUPPLIER_QADATE: 'supplierQaDate',
  SUPPLIER_DIRECTOR_NAME: 'supplierDirectorName',
  SUPPLIER_DIRECTOR_SIGNATURE_BASE64_DATA_TYPE: 'supplierDirectorSignatureBase64DataType',
  SUPPLIER_DIRECTOR_SIGNATURE: 'supplierDirectorSignature',
  SUPPLIER_DIRECTOR_APPROVED: 'supplierDirectorApproved',
  SUPPLIER_DIRECTOR_DATE: 'supplierDirectorDate',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  ACTIVE: 'active',
  AGING: 'aging',};